"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canAmend = void 0;
const url_1 = require("@App/helpers/url");
const canAmend = (amend) => amend || (0, url_1.urlHasComponent)('draft') || (0, url_1.urlHasComponent)('create-work');
exports.canAmend = canAmend;
